module.exports = __webpack_public_path__ + "img/feature_buy_ph.62d343d7.png";